"use strict";
var Observable_1 = require('../../Observable');
var defer_1 = require('../../observable/defer');
Observable_1.Observable.defer = defer_1.defer;
//# sourceMappingURL=defer.js.map


//////////////////
// WEBPACK FOOTER
// F:/Agent/vsts-agent1/_work/76/s/CIA.ClientSide/~/rxjs/add/observable/defer.js
// module id = ../../../../rxjs/add/observable/defer.js
// module chunks = 4